var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmrBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.138,
    height: 18.138,
    viewBox: "0 0 18.138 18.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.014,104.756h-.921a.558.558,0,0,0-.1-.027,6.862,6.862,0,0,1-3.192-1.1,6.916,6.916,0,1,1,10.514-7.349c.08.356.122.719.182,1.079v.921a.811.811,0,0,0-.029.119,7.007,7.007,0,0,1-1.207,3.312.213.213,0,0,0-.016.239c.245.541.482,1.086.726,1.628.173.385.351.768.527,1.153a1.843,1.843,0,0,1-.216-.067q-1.291-.571-2.579-1.148a.241.241,0,0,0-.271.019,6.836,6.836,0,0,1-2.308,1.029C98.758,104.644,98.384,104.691,98.014,104.756Zm.871-4.635c-.041.018-.073.031-.1.047a2.661,2.661,0,0,1-3.851-2.757,2.655,2.655,0,0,1,5.279.321.536.536,0,1,1-1.063.026,1.592,1.592,0,1,0-2.619,1.275,1.563,1.563,0,0,0,1.963.056.176.176,0,0,1,.255,0,1.58,1.58,0,0,0,2.4-.652,2.1,2.1,0,0,0,.083-1.2,3.72,3.72,0,1,0-2.778,4.186,3,3,0,0,0,.96-.4Z",
    transform: "translate(-86.359 -86.618)",
    fill: "#268AF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.439,0c.3.047.595.079.887.142A6.829,6.829,0,0,1,12.791,3.3a.786.786,0,0,1,.045.1A7.738,7.738,0,0,0,5.569,5.57,7.731,7.731,0,0,0,3.4,12.839a.747.747,0,0,1-.153-.08.54.54,0,0,0-.667-.029c-.845.391-1.7.759-2.551,1.136.02-.061.036-.124.062-.182.382-.858.76-1.718,1.149-2.576a.269.269,0,0,0-.022-.3A6.776,6.776,0,0,1,.208,8.546C.12,8.169.066,7.785,0,7.4V6.483c.035-.244.067-.487.106-.73A7,7,0,0,1,5.268.213c.4-.094.81-.142,1.215-.213Z",
    fill: "#268AF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M226.811,226.29a.531.531,0,1,1-.526-.531A.531.531,0,0,1,226.811,226.29Z",
    transform: "translate(-215.087 -215.096)",
    fill: "#268AF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmrBlueIcon);
export default __webpack_public_path__ + "static/media/smrBlue-icon.2979a717c41a5abdf92eb9e62477fe4d.svg";
export { ForwardRef as ReactComponent };